import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';

import { FeedbackService } from '@lockton-apps/shared/ui/lui';
import { MonitoringService } from '@lockton-apps/shared/util/app-monitoring';

import { ErrorService } from './error.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private feedbackService: FeedbackService,
    private errorService: ErrorService,
    private appMonitor: MonitoringService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // Server Error
        const message = this.errorService.getServerErrorMessage(error);
        if (message) {
          this.feedbackService.subtleMessage(message, {
            type: 'error',
          });
        }
        this.appMonitor.logException(error); //todo get context here
        return throwError(() => error);
      })
    );
  }
}
